import _post from "./Post"
import constantURI from "../URI"
import {db, collection, doc, setDoc, getDocs, deleteDoc} from '../firebase';
import ProgressBar from 'react-bootstrap/ProgressBar';
import stylesCommon from "../stylesCommon"
import {set, get} from 'idb-keyval';
import React from "react";
import SYNC from "./sync.png";

export default class CollectingASAP extends React.Component {

    constructor() {
        super();
        this.state = {
            percentage: 0,
            user: [],
            userId: -1,
            items: [],
            products: [],
            pricelist: [],
            pricelistitems: [],
            stock: [],
            result: [],
            count: 0,
            username: "",
            type: "",
            partnerid: -1,
            password:""
        }
    }

    async componentDidMount() {
        const username = JSON.parse(localStorage.getItem("Username"));
        const password = localStorage.getItem("Password");
        const ClientIdGlobal = JSON.parse(localStorage.getItem("ClientIdGlobal"));
        this.setState({username: username , ClientIdGlobal : ClientIdGlobal , password:JSON.parse(password)});
        const token = JSON.parse(localStorage.getItem("Token"));
        const getUserId = constantURI() + "GetUser?token=" + token + "&user=" + username;
        await _post(getUserId).then((response) => {
            return response.json().then((data) => {
                if (data.result !== undefined) {
                    this.setState({user: data.result, userId: data.result[0].id , partnerid : data.result[0].partner_id[0]});
                    localStorage.setItem("UserId", data.result[0].id);
                    localStorage.setItem("User", JSON.stringify(data.result));
                    localStorage.setItem("partnerid", JSON.stringify(data.result[0].partner_id[0]));
                }
            })
        })
        await this.getData();
    }

    getData = async () => {
        const token = JSON.parse(localStorage.getItem("Token"));
        const catalogURL = constantURI() + "GetCatalogs?token=" + token + "&user=" + this.state.username;
        const clientURL = constantURI() + "GetClients?token=" + token + "&user=" + this.state.username + "&userId=" + this.state.userId;
        const vendorURL = constantURI() + "GetVendors?token=" + token + "&user=" + this.state.username;
        const scheduledClientURL = constantURI() + "GetScheduleClients?token=" + token + "&user=" + this.state.username + "&date=" + new Date().toISOString().substring(0, 10);
        const getCountries = constantURI() + "GetCountries?token=" + token + "&user=" + this.state.username;
        const getTitles = constantURI() + "GetTitles?token=" + token + "&user=" + this.state.username;
        const getStates = constantURI() + "GetStates?token=" + token + "&user=" + this.state.username;
        const getPartnerType = constantURI() + "GetPartnerType?token=" + token + "&user=" + this.state.username;
        const getPartnerCategory = constantURI() + "GetPartnerCategory?token=" + token + "&user=" + this.state.username;
        const getPartnerGroup = constantURI() + "GetPartnerGroup?token=" + token + "&user=" + this.state.username;
        const getCurrencies = constantURI() + "GetCurrencies?token=" + token + "&user=" + this.state.username;
        const getPaymentType = constantURI() + "GetPaymentType?token=" + token + "&user=" + this.state.username;
        const getRate = constantURI() + "GetRate?token=" + token + "&user=" + this.state.username;
        const getSOLs = constantURI() + "GetSOLs?token=" + token + "&user=" + this.state.username;
        const getPOLs = constantURI() + "GetPOLs?token=" + token + "&user=" + this.state.username;
        const getILs = constantURI() + "GetInvoiceLines?token=" + token + "&user=" + this.state.username;
        const getSOs = constantURI() + "GetSOs?token=" + token + "&user=" + this.state.username;
        const getPOs = constantURI() + "GetPOs?token=" + token + "&user=" + this.state.username;
        const getInvoives = constantURI() + "GetTransDue?token=" + token + "&user=" + this.state.username + "&userId=" + this.state.userId;
        const getPricelists = constantURI() + "GetAllPricelists?token=" + token + "&user=" + this.state.username;
        const getItems = constantURI() + "GetAllProductTemp?token=" + token + "&user=" + this.state.username;
        //const getPricelists = constantURI() + "GetPricelists?token=" + token+"&user="+this.state.username+ "&id=" + 24;
        //const getItems = constantURI() + "GetProductTemp?token=" + token+"&user="+this.state.username+ "&pricelistId=" + 24;
        const getTaxes = constantURI() + "GetTaxes?token=" + token + "&user=" + this.state.username;
        const getLocations = constantURI() + "GetLocations?token=" + token + "&user=" + this.state.username;
        const GetReps = constantURI() + "GetReps?token=" + token + "&user=" + this.state.username;
        const getProductCateg = constantURI() + "GetProductCateg?token=" + token + "&user=" + this.state.username;
        const getProductFamily = constantURI() + "GetProductFamily?token=" + token + "&user=" + this.state.username;
        const getProductGroup = constantURI() + "GetProductGroup?token=" + token + "&user=" + this.state.username;
        const getProductBrand = constantURI() + "GetProductBrand?token=" + token + "&user=" + this.state.username;
        const getCurrencyRate = constantURI() + "GetCurrencyRate?token=" + token + "&user=" + this.state.username;
        const getSalesType = constantURI() + "GetSalesType?token=" + token + "&user=" + this.state.username;
        const getSetting =  constantURI() + "GetSettings?user=" + this.state.username + "&clientId=" + this.state.ClientIdGlobal;
        // const getproductPromotions = constantURI() + "GetproductPromotions?token=" + token + "&username=" + this.state.username + "&password=" + this.state.password;
        const GetSalesPersonTargetList = constantURI() + "GetSalesPersonTargetList?token=" + token + "&user=" + this.state.username+ "&SalesPersonId=" + this.state.username;
        this.setState({type: "Reps"});
        console.log("Start Time Vendors:" + new Date());
        await _post(vendorURL).then((response) => {
            return response.json().then(async (data) => {
                if (data.result !== undefined) {
                    localStorage.setItem("Vendors", JSON.stringify(data.result));
                    this.setState({percentage: this.state.percentage + 4});
                    console.log("End Time Vendors:" + new Date());
                    console.log(data.result.length);
                }
            })
        });
        //   await _post(getproductPromotions).then((response) => {
        //     return response.json().then(async (data) => {
        //         if (data !== undefined) {
        //             localStorage.setItem("ProductPromotion", JSON.stringify(data));
        //             this.setState({percentage: this.state.percentage + 2});
        //             console.log("End Time ProductPromotion:" + new Date());
                    
        //         }
        //     })
        // });
        await _post(getSalesType).then((response) => {
            return response.json().then(async (data) => {
                if (data.result !== undefined) {
                    localStorage.setItem("SalesType", JSON.stringify(data.result));
                    this.setState({percentage: this.state.percentage + 4});
                    console.log("End Time SalesType:" + new Date());
                    console.log(data.result.length);
                }
            })
        });
        console.log("Start Time Target:" + new Date());
        // await _post(GetSalesPersonTargetList).then((response) => {
        //     return response.json().then(async (data) => {
        //         if (data.result !== undefined) {
        //             localStorage.setItem("Target", JSON.stringify(data.result[0]));
        //             this.setState({percentage: this.state.percentage + 2});
        //             console.log("End Time Target:" + new Date());
        //             console.log(data.result.length);
        //         }
        //     })
        // });
        await _post(getCurrencyRate).then((response) => {
            return response.json().then(async (data) => {
                if (data.result !== undefined) {
                    localStorage.setItem("CurrencyRate", JSON.stringify(data.result));
                    this.setState({percentage: this.state.percentage + 2});
                    console.log("End Time CurrencyRate:" + new Date());
                    console.log(data.result.length);
                }
            })
        });
        console.log("Start Time Prod Family:" + new Date());
        await _post(getProductFamily).then((response) => {
            return response.json().then(async (data) => {
                if (data.result !== undefined) {
                    localStorage.setItem("ProductFamily", JSON.stringify(data.result));
                    this.setState({percentage: this.state.percentage + 3.5});
                    console.log("End Time Prod Family:" + new Date());
                    console.log(data.result.length);
                }
            })
        });
        console.log("Start Time Prod Categ:" + new Date());
        await _post(getProductCateg).then((response) => {
            return response.json().then(async (data) => {
                if (data.result !== undefined) {
                    localStorage.setItem("ProductCateg", JSON.stringify(data.result));
                    localStorage.setItem('CatalogId', JSON.stringify(1));
                    this.setState({percentage: this.state.percentage + 3.5});
                    console.log("End Time Prod Categ:" + new Date());
                    console.log(data.result.length);
                }
            })
        });
        console.log("Start Time Prod Brand:" + new Date());
        await _post(getProductBrand).then((response) => {
            return response.json().then(async (data) => {
                if (data.result !== undefined) {
                    localStorage.setItem("ProductBrand", JSON.stringify(data.result));
                    this.setState({percentage: this.state.percentage + 3.5});
                    console.log("End Time Prod Brand:" + new Date());
                    console.log(data.result.length);
                }
            })
        });
        console.log("Start Time Prod Group:" + new Date());
        await _post(getProductGroup).then((response) => {
            return response.json().then(async (data) => {
                if (data.result !== undefined) {
                    localStorage.setItem("ProductGroup", JSON.stringify(data.result));
                    this.setState({percentage: this.state.percentage + 3.5});
                    console.log("End Time Prod Group:" + new Date());
                    console.log(data.result.length);
                }
            })
        });
        console.log("Start Time Prod setting:" + new Date());
        await _post(getSetting).then((response) => {
            return response.json().then(async (data) => {
                if (data.settingArray !== null) {
                    localStorage.setItem("SettingArray", JSON.stringify(data.settingArray));
                    const defaultCurrencySetting =  data.settingArray.find((item) => {
                        const key = String(item?.key ?? "").trim().toLowerCase();
                        return key === "default currency" || key === "defaultcurrency";
                        });
                    const defaultCurrency = defaultCurrencySetting ? JSON.parse(defaultCurrencySetting.value) : null;
                    if (defaultCurrency) {
                        localStorage.setItem("DefaultCurrencyId", defaultCurrency.id);
                        localStorage.setItem("DefaultCurrencyName", defaultCurrency.name);
                    }
                    this.setState({percentage: this.state.percentage + 3.5});
                    console.log("End Time Prod setting:" + new Date());
                
                }
            })
        });
        console.log("Start Time Reps:" + new Date());
        await _post(GetReps).then((response) => {
            return response.json().then(async (data) => {
                if (data.result !== undefined) {
                    localStorage.setItem("Representative", JSON.stringify(data.result));
                    this.setState({percentage: this.state.percentage + 3.5});
                    
                    console.log("End Time Reps:" + new Date());
                    console.log(data.result.length);
                }
            })
        });
        this.setState({type: "ScheduledClient"});
        console.log("Start Time ScheduledClients:" + new Date());
        await _post(scheduledClientURL).then((response) => {
            return response.json().then(async (data) => {
                if (data.result !== undefined) {
                    localStorage.setItem('ScheduledClients', JSON.stringify(data.result));
                    this.setState({percentage: this.state.percentage + 3.5});
                   
                    console.log("End Time ScheduledClients:" + new Date());
                    console.log(data.result.length);
                }
            })
        })
        this.setState({type: "Countries"});
        console.log("Start Time Countries:" + new Date());
        await _post(getStates).then((response) => {
            return response.json().then((data) => {
                if (data.result !== undefined) {
                    localStorage.setItem('Countries', JSON.stringify(data.result));
                    this.setState({percentage: this.state.percentage + 3.5});
                    this.setState({type: "Countries"});
                    console.log("End Time Countries:" + new Date());
                    console.log(data.result.length);
                }
            })
        })
        this.setState({type: "Type"});
        console.log("Start Time Type:" + new Date());
        await _post(getPartnerType).then((response) => {
            return response.json().then((data) => {
                if (data.result !== undefined) {
                    localStorage.setItem('Type', JSON.stringify(data.result));
                    this.setState({percentage: this.state.percentage + 3.5});
                    
                    console.log("End Time Type:" + new Date());
                    console.log(data.result.length);
                }
            })
        })
        this.setState({type: "Title"});
        console.log("Start Time Title:" + new Date());
        await _post(getTitles).then((response) => {
            return response.json().then((data) => {
                if (data.result !== undefined) {
                    localStorage.setItem('Title', JSON.stringify(data.result));
                    this.setState({percentage: this.state.percentage + 3.5});
                    
                    console.log("End Time Title:" + new Date());
                    console.log(data.result.length);
                }
            })
        })
        this.setState({type: "Potential"});
        console.log("Start Time Potential:" + new Date());
        await _post(getPartnerCategory).then((response) => {
            return response.json().then((data) => {
                if (data.result !== undefined) {
                    localStorage.setItem('Potential', JSON.stringify(data.result));
                    this.setState({percentage: this.state.percentage + 3.5});
               
                    console.log("End Time Potential:" + new Date());
                    console.log(data.result.length);
                }
            })
        })
        this.setState({type: "Specialties"});
        console.log("Start Time Specialties:" + new Date());
        await _post(getCountries).then((response) => {
            return response.json().then((data) => {
                if (data.result !== undefined) {
                    localStorage.setItem('Specialties', JSON.stringify(data.result));
                    this.setState({percentage: this.state.percentage + 3.5});
                   
                    console.log("End Time Specialties:" + new Date());
                    console.log(data.result.length);
                }
            })
        })
        this.setState({type: "Group"});
        console.log("Start Time Group:" + new Date());
        await _post(getPartnerGroup).then((response) => {
            return response.json().then((data) => {
                if (data.result !== undefined) {
                    localStorage.setItem('Group', JSON.stringify(data.result));
                    this.setState({percentage: this.state.percentage + 3.5});
                    
                    console.log("End Time Group:" + new Date());
                    console.log(data.result.length);
                }
            })
        })
        this.setState({type: "Currency"});
        console.log("Start Time Currency:" + new Date());
        await _post(getCurrencies).then((response) => {
            return response.json().then((data) => {
                if (data.result !== undefined) {
                    localStorage.setItem('Currency', JSON.stringify(data.result));
                    this.setState({percentage: this.state.percentage + 3.5});
                   
                    console.log("End Time Currency:" + new Date());
                    console.log(data.result.length);
                }
            })
        });
        this.setState({type: "Taxes"});
        console.log("Start Time Taxes:" + new Date());
        await _post(getTaxes).then((response) => {
            return response.json().then((data) => {
                if (data.result !== undefined) {
                    localStorage.setItem('Taxes', JSON.stringify(data.result));
                    this.setState({percentage: 48});
                    
                    console.log("End Time Taxes:" + new Date());
                    console.log(data.result.length);
                }
            })
        });
        this.setState({type: "Location"});
        console.log("Start Time Location:" + new Date());
        await _post(getLocations).then((response) => {
            return response.json().then((data) => {
                if (data.result !== undefined) {
                    localStorage.setItem('Location', JSON.stringify(data.result));
                    this.setState({percentage: this.state.percentage + 3.5});
                    
                    console.log("End Time Location:" + new Date());
                    console.log(data.result.length);
                }
            })
        });
        this.setState({type: "Catalogs"});
        console.log("Start Time Catalogs:" + new Date());
        await _post(catalogURL).then((response) => {
            return response.json().then((data) => {
                if (data.result !== undefined) {
                    localStorage.setItem('Catalogs', JSON.stringify(data.result));
                    this.setState({percentage: this.state.percentage + 3.5});
                   
                    console.log("End Time Catalogs:" + new Date());
                    console.log(data.result.length);
                }
            })
        });
        this.setState({type: "InvoicesLines"});
        console.log("Start Time InvoicesLines:" + new Date());
        // await _post(getILs).then((response) => {
        //     return response.json().then((data) => {
        //         if (data.result !== undefined) {
        //             localStorage.setItem('InvoicesLines', JSON.stringify(data.result));
        //             this.setState({percentage: this.state.percentage + 3.5});
                   
        //             console.log("End Time InvoicesLines:" + new Date());
        //             console.log(data.result.length);
        //         }
        //     })
        // });
        this.setState({type: "Rates"});
        console.log("Start Time Rates:" + new Date());
        await _post(getRate).then((response) => {
            return response.json().then((data) => {
                if (data.result !== undefined) {
                    localStorage.setItem('Rates', JSON.stringify(data.result));
                    this.setState({percentage: this.state.percentage + 3.5});
                   
                    console.log("End Time Rates:" + new Date());
                    console.log(data.result.length);
                }
            })
        });

        this.setState({type: "PaymentTypes"});
        console.log("Start Time PaymentTypes:" + new Date());
        await _post(getPaymentType).then((response) => {
            return response.json().then((data) => {
                console.log("Odoo PaymentTypes:" + new Date());
                if (data.result !== undefined) {
                    localStorage.setItem('PaymentTypes', JSON.stringify(data.result));
                    this.setState({percentage: this.state.percentage + 3.5});
                   
                    console.log("End Time PaymentTypes:" + new Date());
                    console.log(data.result.length);
                }
            })
        });
        this.setState({type: "Purchase"});
        console.log("Start Time Purchase:" + new Date());
        await _post(getPOs).then((response) => {
            return response.json().then(async (data) => {
                console.log("Odoo Purchase:" + new Date());
                if (data.result !== undefined && data.result !== null) {
                    try {
                        // Use 'set' method from idb-keyval to add data to IndexedDB
                        await set('Purchase', data.result);

                        console.log('Purchase added to IndexedDB successfully!');
                        console.log(data.result);
                        this.setState({percentage: this.state.percentage + 4});
                        
                        console.log("End Time Purchase:" + new Date());
                      } catch (error) {
                        console.error('Error adding Purchase to IndexedDB:', error);
                    }
                }
            })
        })
       
        this.setState({type: "PriceList"});
        
        console.log("Start Time FBPriceList:" + new Date());
        await _post(getPricelists).then((response) => {
            return response.json().then(async (data) => {
                console.log("Odoo FBPriceList:" + new Date());
                if (data.result !== undefined && data.result !== null) {
                    try {
                        // Use 'set' method from idb-keyval to add data to IndexedDB
                        await set('PriceList', data.result);
                        console.log('PriceList added to IndexedDB successfully!');
                        console.log(data.result);
                        this.setState({percentage: this.state.percentage + 4});
                       
                        console.log("End Time FBPriceList:" + new Date());
                      } catch (error) {
                        console.error('Error adding PriceList to IndexedDB:', error);
                    }
                }
            })
        })
       
        this.setState({type: "PurchaseLines"});
        
        console.log("Start Time PurchaseLines:" + new Date());
        // await _post(getPOLs).then((response) => {
        //     return response.json().then(async (data) => {
        //         console.log("Odoo PurchaseLines:" + new Date());
        //         if (data.result !== undefined && data.result !== null) {
        //             try {
        //                 // Use 'set' method from idb-keyval to add data to IndexedDB
        //                 await set('PurchaseLines', data.result);
        //                 console.log('PurchaseLines added to IndexedDB successfully!');
        //                 console.log(data.result);
        //                 this.setState({percentage: this.state.percentage + 4});
                      
        //                 console.log("end Time PurchaseLines:" + new Date());
        //               } catch (error) {
        //                 console.error('Error adding PurchaseLines to IndexedDB:', error);
        //             }

        //         }
        //     })
        // })
        this.setState({type: "Orders"});
         
        console.log("Start Time FBOrders:" + new Date());
        await _post(getSOs).then((response) => {
            return response.json().then(async (data) => {
                console.log("Odoo FBOrders:" + new Date());
                if (data.result !== undefined && data.result !== null) {
                    try {
                        // Use 'set' method from idb-keyval to add data to IndexedDB
                        await set('Orders', data.result);

                        console.log('Orders added to IndexedDB successfully!');
                        console.log(data.result);
                        this.setState({percentage: this.state.percentage + 4});
                      
                        console.log("end Time FBOrders:" + new Date());
                      } catch (error) {
                        console.error('Error adding Orders to IndexedDB:', error);
                    }
                }
            });
        });
        this.setState({type: "Invoices"});
        console.log("Start Time FBInvoices:" + new Date());
        await _post(getInvoives).then((response) => {
            return response.json().then(async (data) => {
                console.log("Odoo FBInvoices:" + new Date());
                if (data.result !== undefined && data.result !== null) {
                    try {
                        // Use 'set' method from idb-keyval to add data to IndexedDB
                        await set('Invoices', data.result);
                        console.log('Invoices added to IndexedDB successfully!');
                        console.log(data.result);
                        this.setState({percentage: this.state.percentage + 4});
                     
                        console.log("end Time FBInvoices:" + new Date());
                      } catch (error) {
                        console.error('Error adding Invoices to IndexedDB:', error);
                    }
                }
            })
        })
        
        this.setState({type: "OrderLines"});
        console.log("Start Time FBOrderLines:" + new Date());
        await _post(getSOLs).then((response) => {
            return response.json().then(async (data) => {
                console.log("Odoo FBOrderLines:" + new Date());
                if (data.result !== undefined && data.result !== null) {
                    try {
                        // Use 'set' method from idb-keyval to add data to IndexedDB
                        await set('OrderLines', data.result);
                        console.log('OrderLines added to IndexedDB successfully!');
                        console.log(data.result);
                        this.setState({percentage: this.state.percentage + 4});
                      
                        console.log("end Time FBOrderLines:" + new Date());
                      } catch (error) {
                        console.error('Error adding OrderLines to IndexedDB:', error);
                    }
                }
            })
        })
        

        this.setState({type: "Clients"});
        console.log("Start Time FBClients:" + new Date());
        await _post(clientURL).then((response) => {
            return response.json().then(async (data) => {
                console.log("Odoo FBClients:" + new Date());
                if (data.result !== undefined && data.result !== null) {
                    try {
                        // Use 'set' method from idb-keyval to add data to IndexedDB
                        await set('Clients', data.result);
                        console.log('Clients added to IndexedDB successfully!');
                        console.log(data.result);
                        this.setState({percentage: this.state.percentage + 4});
                       
                        console.log("end Time FBClients:" + new Date());
                      } catch (error) {
                        console.error('Error adding Clients to IndexedDB:', error);
                    }
                }
            })
        })
       
        this.setState({type: "Items"});
        console.log("Start Time Items:" + new Date());
        await _post(getItems).then((response) => {
            return response.json().then(async (data) => {
                console.log("Odoo items:" + new Date());
                if (data.result !== undefined && data.result !== null) {
                    try {
                        // Use 'set' method from idb-keyval to add data to IndexedDB
                        await set('items', data.result);
                        
                        console.log('items added to IndexedDB successfully!');
                        this.setState({percentage: 100});
                        console.log("End Time Items:" + new Date());
                        console.log(getItems)
                        this.props.isDone(true);
                        this.props.history.push("/LandingPage");
                    } catch (error) {
                        console.error('Error adding items to IndexedDB:', error);
                    }
                }
            })
        })
    }

    render() {
        return (
            <div className="sync container-fluid vh-100 text-center" >
                {(this.state.percentage === 100) ?
                    <h1 className="pt-5">Data Received!</h1>
                    : <div>
                        <h3 className="pt-5">Receiving data. This may take few seconds.</h3>
                        <ProgressBar animated now={this.state.percentage}/>
                        <h3 className="mt-3">{this.state.percentage + "%"+ "   " + this.state.type}</h3>
                        <img src={SYNC} className="sync1 mt-5" alt="SYNC" />
                    </div>
                }
            </div>
        );
    }
}
